// extracted by mini-css-extract-plugin
export default {"price":"i8-z","onSale":"j8-z","msrpLabelPrice":"k8-z","msrpLabel":"l8-z","originalPrice":"m8-z","percentOff":"n8-z"};